import { Script } from "gatsby";
import React from "react";
import { SITE_URL, KLAVIYO_B2B_ID, KLAVIYO_COMPANY_ID, CURRENT_COUNTRY } from "utils/constants";

const isDevStore = SITE_URL.includes("dev");

const MetaTags = ({ meta, path }) => {
	if (!meta) return <></>;
	const { title, description, image, noIndex } = meta;

	const cleanUrl = SITE_URL.replace("www.", "");

	const showB2BID = CURRENT_COUNTRY !== "nl" && path === "/b2b";

	return (
		<>
			<html rel="alternate" href={SITE_URL} lang={process.env.GATSBY_COUNTRY} translate="no" />
			<title>{`${title} - Every`}</title>
			<link rel="canonical" href={`${cleanUrl}${path}`} />
			<meta name="google" content="notranslate" />
			{/* {IS_PRODUCTION && ( */}
			<Script
				async
				type="text/javascript"
				src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${showB2BID ? KLAVIYO_B2B_ID : KLAVIYO_COMPANY_ID}`} />
			{/* // )} */}
			<meta property="og:site_name" content="Every-foods"></meta>
			<meta property="og:url" content={`${cleanUrl}${path}`}></meta>
			<meta property="og:title" content={title}></meta>
			<meta property="og:type" content="website"></meta>
			<meta name="description" property="og:description" content={description}></meta>
			<meta property="og:image" content={image}></meta>
			{(noIndex || isDevStore) && <meta name="robots" content="noindex" />}

			{/* Twitter Card*/}
			<meta name="twitter:card" content="summary_large_image"></meta>
			<meta name="twitter:title" content={title}></meta>
			<meta name="twitter:description" content={description}></meta>
			<meta name="twitter:image" content={image}></meta>
			<meta property="twitter:domain" content={SITE_URL}></meta>
			<meta property="twitter:url" content={SITE_URL}></meta>
		</>
	);
};

export default MetaTags;
